<script>
import { HorizontalBar } from 'vue-chartjs'

export default {
  extends: HorizontalBar,
  props: ['options','height','width','parRliss'],
  methods: {
    newData: function() {
      this.renderChart(
        this.chartData,
        {
          legend: {
            position: 'right'
          },
          title: {
            display: true,
            fontSize: 20,
            text: 'Plans en souffrance'
          },
          scales: {
            // yAxes: [{
            //   stacked: true
            // }],
            xAxes: [{
              scaleLabel: {
                display: true,
                labelString: 'Nombre de FSS'
              },
              // stacked: true
            }]
          },
          animation: {
            duration: 500,
          },
        }
      )
    }
  },
  computed: {
    sortedData: function() {
      return this.parRliss.slice()
      .sort((a,b) => (a.rliss_fr.localeCompare(b.rliss_fr)))
    },
    labels: function() {
      return this.sortedData.map(x => x.rliss_fr);
    },
    // datasets
    total() {
      return this.sortedData.map(x => x.total);
    },
    nonDebute() {
      return this.sortedData.map(x => x.pas_debute);
    },
    enDevOuMaj() {
      return this.sortedData.map(x => x.en_dev_maj);
    },
    pasSoumisLanPasse() {
      return this.sortedData.map(x => x.pas_soumis);
    },
    pasDeCompte() {
      return this.sortedData.map(x => x.no_user);
    },

    chartData() {
      return {
        labels: this.labels,
        datasets: [
          // {
          //   data: this.total,
          //   fill: true,
          //   backgroundColor: "#3D89B3",
          //   label: "Total"
          // },
          {
            data: this.nonDebute,
            fill: true,
            backgroundColor: "#3D89B3",
            label: "Non-débutés"
          },
          {
            data: this.enDevOuMaj,
            fill: true,
            backgroundColor: "#B3874F",
            label: "Dev/M-à-j"
          },
          {
            data: this.pasDeCompte,
            fill: true,
            backgroundColor: "#8AD5FF",
            label: "Pas de compte"
          },
          {
            data: this.pasSoumisLanPasse,
            fill: true,
            backgroundColor: "#FFCC8A",
            label: "Pas soumis en 17-18"
          },
        ]
      }
    }
  },
  watch: {
    parRliss: function() {
      this.newData();
      // this.$data._chart.update();
      // this.update();
    }
  },
  mounted() {
    this.newData();
    // this.renderChart(this.chartdata, this.options)
    // this.renderChart({data: [10,14,15]}, this.options)
  }
}
</script>
